import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "./dropContentPresentation";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly mediaContainerHeightClassName?: string | undefined;
  readonly fullWidthMedia?: boolean | undefined;
  readonly hasTouch?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(23);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    mediaContainerHeightClassName,
    fullWidthMedia: t5,
    hasTouch,
    onLinkCardActionsActiveChange,
    contentPresentation: t6,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const contentPresentation = t6 === undefined ? "default" : t6;
  const isTouchDevice = useIsTouchDevice();
  const effectiveHasTouch = hasTouch ?? isTouchDevice;
  let t7;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== effectiveHasTouch || $[4] !== embedDepth || $[5] !== embedPath || $[6] !== fullWidthMedia || $[7] !== isCompetitionDrop || $[8] !== isEditing || $[9] !== isSaving || $[10] !== maxEmbedDepth || $[11] !== mediaContainerHeightClassName || $[12] !== mediaImageScale || $[13] !== onCancel || $[14] !== onDropContentClick || $[15] !== onLinkCardActionsActiveChange || $[16] !== onLongPress || $[17] !== onQuoteClick || $[18] !== onSave || $[19] !== quotePath || $[20] !== setActivePartIndex || $[21] !== setLongPressTriggered) {
    t7 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} mediaContainerHeightClassName={mediaContainerHeightClassName} fullWidthMedia={fullWidthMedia} hasTouch={effectiveHasTouch} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = effectiveHasTouch;
    $[4] = embedDepth;
    $[5] = embedPath;
    $[6] = fullWidthMedia;
    $[7] = isCompetitionDrop;
    $[8] = isEditing;
    $[9] = isSaving;
    $[10] = maxEmbedDepth;
    $[11] = mediaContainerHeightClassName;
    $[12] = mediaImageScale;
    $[13] = onCancel;
    $[14] = onDropContentClick;
    $[15] = onLinkCardActionsActiveChange;
    $[16] = onLongPress;
    $[17] = onQuoteClick;
    $[18] = onSave;
    $[19] = quotePath;
    $[20] = setActivePartIndex;
    $[21] = setLongPressTriggered;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default WaveDropContent;